import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface SectionRedirectProps {
  sectionId: string;
}

const SectionRedirect = ({ sectionId }: SectionRedirectProps) => {
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();
  const prefix = lang ? `/${lang}` : '';

  useEffect(() => {
    navigate(`${prefix}/#${sectionId}`, { replace: true });
  }, [navigate, sectionId, prefix]);

  return null;
};

export default SectionRedirect;
